export default "__VITE_ASSET__e519a9ff__"